/**
 * Audio level constants
 */
export const DEFAULT_MUSIC_VOLUME = 50;
export const DEFAULT_ATC_VOLUME = 25;
export const MIN_VOLUME = 0;
export const MAX_VOLUME = 100;

/**
 * Animation timing constants
 */
export const FADE_ANIMATION_DURATION = 300; // ms
export const SPLASH_SCREEN_DURATION = 4000; // ms
export const VOLUME_CONTROL_HIDE_DELAY = 200; // ms

/**
 * Media constants
 */
export const ATC_RECORDS_COUNT = 48; // Number of ATC records to fetch

/**
 * App specific constants
 */
export const STREAK_INCREMENT_THRESHOLD = 15 * 60 * 1000; // 15 minutes in milliseconds